interface FeatureListTitleProps {
    title: string;
}
export const FeatureListTitle: React.FC<FeatureListTitleProps> = ({ title }) => {
    return <p className="text-2xl font-medium mt-6">{title}</p>;
};
